/* eslint-disable @typescript-eslint/no-explicit-any */
import { ElioError, toElioError } from '@elio/shared/models';
import { catchError, Observable, OperatorFunction } from 'rxjs';

export const catchElioError = <I, O>(
  selector: (elioError: ElioError, caught: Observable<I>) => Observable<O>
): OperatorFunction<I, I | O> => {
  return catchError((error: unknown, caught) => {
    return selector(toElioError(error), caught);
  });
};
